<template>
	<div class="assets-view container-fluid">
		<div class="row">
			<div class="col-12 main">
				<div class="assets-block" :data-dev-info="`{ type: 'module', id: '${siteId}' }`">
					<div v-for="(item, index) in objectdataImageItems"
					     class="item"
					     :key="item.key"
					     @click="openSidebarFor(item)">
						<b-card class="card_ mb-5"
						        :data-dev-info="`{ type: 'item', id: '${item.key}', position: ${item.U_Position} }`"
	                            header-tag="header" :class="{'_error': item.mandatory === 'true' && item.value === '', '_focus-outline': isSidebarFocused(item)}">
							<div slot="header"
							     class="_image"
							     :style="`background-image: url('${getImgSrc(index)}')`">
							</div>
							<span :data-infotextkey="infoTextKeyForItem(item)">
								{{ item.label }}
								<erco-tooltip v-if="infoTextForItem(item)"
								              :variant="infoTextForItem(item).variant"
								              :title="infoTextForItem(item).title"
								              :text="infoTextForItem(item).text">
								</erco-tooltip>
							</span>
	                    </b-card>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import InfoText from '@/helper/infoTextHelper';
	import renderHelper from '@/helper/renderHelper';

	import ErcoTooltip from '@/components/molecules/ErcoTooltip';

	export default {
		name: 'ErcoObjectViewAssetsOrganism',

		data() {
			return {
				imgSrcs: {},
			};
		},

		props: {
			dataset: {
				type: Object,
				required: true,
			},
		},

		computed: {
			objectdataImageItems() {
				return this.$store.getters.mappedObjectDataItems.imageItems;
			},

			siteId() {
				return this.$store.state.objectsites.objectdata.id;
			},
		},

		mounted() {
			Object.keys(this.$store.getters.mappedObjectDataItems.imageItems)
				.forEach((index) => {
					const data = this.$store.getters.mappedObjectDataItems.imageItems[index];
					renderHelper.getImage(data, (img) => {
						Vue.set(this.imgSrcs, index, img);
					});
				});
		},

		methods: {
			openSidebarFor(item) {
				const outputData = item;

				const sidebarData = {
					visible: true,
					key: this.getItemKey(item),
					view: 'erco-sidebar-image-editor',
					outputData,
					context: {
						dispatchActionName: 'updateAssetsItem',
						value: {},
					},
					title: item.S_Urbild,
					titleAdditional: item.label,
					info: InfoText.for('assets.editAsset'),
				};

				this.$store.dispatch('updateSidebar', sidebarData);
			},

			getImgSrc(key) {
				return this.imgSrcs[key];
			},

			getItemKey(item) {
				const key = item.label.toLowerCase()
					.replace(/\s*\(.*?\)\s*/g, '')
					.replace(/\s/, '_')
					.replace(/[*:]|\s+/g, '')
					.trim();
				return key;
			},

			infoTextKeyForItem(item) {
				return `assets.${this.getItemKey(item)}`;
			},

			infoTextForItem(item) {
				const key = this.infoTextKeyForItem(item);
				return InfoText.for(key);
			},

			isSidebarFocused(item) {
				const key = this.getItemKey(item);
				const sidebarStore = this.$store.state.sidebar;
				return sidebarStore.visible && sidebarStore.key === key;
			},
		},

		watch: {
			objectdataImageItems() {
				Object.keys(this.$store.getters.mappedObjectDataItems.imageItems)
					.forEach((index) => {
						const data = this.$store.getters.mappedObjectDataItems.imageItems[index];
						renderHelper.getImage(data, (img) => {
							Vue.set(this.imgSrcs, index, img);
						});
					});
			},
		},

		components: {
			ErcoTooltip,
		},
	};
</script>

<style lang="scss">
	.assets-view {
		.main {
			background-color: rgba(242, 242, 242, 1);
			padding: 1.5rem 4rem;

			.assets-block {
				display: flex;
				flex-flow: row wrap;
				justify-content: space-between;

				& > .item {
					padding: 0;
					flex-basis: 300px;

					& > .card_ {

						&._focus-outline {
							border-color: #5cb3fd !important;
							outline: none;
						}

						&._error {
							border: 1px solid red;
						}

						.card-header {
							padding: 0;
						}

						._image {
							height: 200px;
							background-size: contain;
							background-position: center center;
							background-repeat: no-repeat;
							/* background-color: rgba(237, 236, 235, 1); */
						}
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// Assets.vue?646b8f7c